<div class="content-card-mini-list">
  <app-content-card-mini
    *ngFor="let item of items; trackBy: trackByFn"
    linkEnable="true"
    [item]="item">
  </app-content-card-mini>
</div>
